export const podcasts = [{
    "episode": 1,
    "judul": 'Makna Peziarah',
    "description": 'Alasan mengapa podcast ini dinamakan podcast peziarah',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/5Je5gLGjd2b5uDd7am5AO7?si=OwZCBtv8RMeTszEUWE6PiA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-1--Makna-Peziarah-e8mqlv',
    }
  },
  {
    "episode": 2,
    "judul": 'Cerita tentang YOUCAT Indonesia',
    "description": 'Asal muasal terbentuknya YOUCAT dan apa yang YOUCAT Indonesia lakukan sebagai upaya pewartaan iman katolik kepada anak muda. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/2B0IcS9N8xlTJOnRxsVaPF?si=ZubHQH69TgWETG8g7iA0ow',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-2--Cerita-tentang-YOUCAT-Indonesia-e8mqmn',
    }
  },
  {
    "episode": 3,
    "judul": 'Berefleksi = Bercermin? (Segmen Refleksi)',
    "description": 'Refleksi tentang apa dan kenapa penting bagi kita melakukan refleksi terhadap diri?',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/3sB7Co1E44zLIkkDppIl9q?si=5ER2ds-TTuOM_bUintZ-Wg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-3--Berefleksi--Bercermin--Segmen-Refleksi-e8tamv',
    }
  },
  {
    "episode": 4,
    "judul": 'Peran Kardinal dalam Gereja',
    "description": 'Siapa Kardinal dan apa peran Kardinal di dalam gereja?',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/51zhdWvBbSqil8sJRZ9jsi?si=Xz-W0eqbRFa216UJ8NKKBQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-4--Peran-Kardinal-dalam-Gereja-e8toj4',
    }
  },
  {
    "episode": 5,
    "judul": 'Pelantikan Y.U. Ignatius Kardinal Suharyo',
    "description": 'Kegembiraan umat Katolik di Indonesia atas pelantikan Y.U. Ignatius Kardinal Suharyo dan makna dibaliknya',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/2RD4TyfCaFLqq3mDU4dz2g?si=xmSuMN25T-awzMvBMMJ5IQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-5-Pelantikan-Y-U--Ignatius-Kardinal-Suharyo-e8vfqp',
    }
  },
  {
    "episode": 6,
    "judul": 'Tugas dan Fungsi Uskup',
    "description": 'Apa Tugas dan fungsi Uskup di dalam gereja, serta mengenal lebih jauh perbedaan Uskup dan Kardinal. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4G2KZJjwBVCZlNqbxg5cRi?si=tBYtxFK0S-ePFVkbCl28sA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-6-Tugas-dan-Fungsi-Uskup-e91eph',
    }
  },
  {
    "episode": 7,
    "judul": 'Memaknai Persekutuan Para Kudus',
    "description": 'Mengenal lebih jauh tentang Hari Raya Semua Orang Kudus dan makna Persekutuan Para Kudus',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/6QCcCWyh8yNm32535P4090?si=GBlZAH5_TFujS_Rfnb4-MQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-7-Memaknai-Persekutuan-Para-Kudus-e928va',
    }
  },
  {
    "episode": 8,
    "judul": 'Kehidupan Setelah Kematian',
    "description": 'Penjelasan tentang kehidupan setelah kematian dan esensi hari raya semua arwah orang beriman.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4EXORm6m3nfuIYIOUVILLA?si=OGcnc8GzS8u3EKIzsx4fkg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-8-Kehidupan-Setelah-Kematian-e9290g',
    }
  },
  {
    "episode": 9,
    "judul": 'Beriman Layaknya Bersahabat (Segmen Refleksi) ',
    "description": 'Refleksi unutk mengenal dan merasakan kehadiran Tuhan, mengembangkan iman, serta mewujudkannya dalam keseharian. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4VvIQLQh8TrbOj8Diig0Oo?si=jJ2w0iGSSHWvCidfby78FQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-9-Beriman-Layaknya-Bersahabat-Segmen-Refleksi-e9291s',
    }
  },
  {
    "episode": 10,
    "judul": 'Menjadi Orang Kudus ',
    "description": 'Proses menjadi orang kudus dan bagaimana kita meraih kekudusan melalui kegiatan keseharian',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/55UAKlJTialoAFYdG87ZJk?si=_nsmREqmRAW5UPkZuQSXdw',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-10-Menjadi-Orang-Kudus-e96bhc',
    }
  },
  {
    "episode": 11,
    "judul": 'Mengetahui Apa yang Kita Imani',
    "description": 'Berkenalan dengan "Aku Tahu Imanku" (@akutahuimanku) dan bersama-sama merenungkan bagaimana cara kita semakin mengetahui apa yang kita imani. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/5b2NtAAg7yCwwJbUe52ok3?si=rf_F9CqEThiCh7SfQOU3GA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-11-Mengetahui-Apa-yang-Kita-Imani-e97jng',
    }
  },
  {
    "episode": 12,
    "judul": 'Mengenal ADVENTure† 2019 YOUCAT Indonesia',
    "description": 'YOUCAT mengajak kita untuk bersama-sama berpetualang di Masa Adven (ADVENTure) untuk siapkan hati menyambut kedatangan Sang Juru Selamat dengan melakukan hal-hal positif seturut dengan kehendak-Nya)',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/5L1yTOCVcBVgD6KLPIKK6F?si=Wnltcs2FTWyXLbtJ2hDyLA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-12-Mengenal-ADVENTure-2019-YOUCAT-Indonesia-e98gca',
    }
  },
  {
    "episode": 13,
    "judul": 'Memahami dan Memaknai Masa Adven',
    "description": 'Menggali, memahami, serta memaknai Masa Adven, Lingkaran Adven, dan apa saja yang seharusnya kita lakukan untuk mengisi Masa Adven.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/68oPvdaklGowpPcH8w3Hky?si=VZx85otuSlOmUxnFUkcqrQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps--13-Memahami-dan-Memaknai-Masa-Adven-e99nbf',
    }
  },
  {
    "episode": 14,
    "judul": 'Mengenal St. Fransiskus Xaverius (Pelindung Misi)',
    "description": 'Mengenal dan merayakan Pesta Santo Fransiskus Xaverius sebagai Imam dan Pelindung Karya Misi, yang telah bermisi ke berbagai penjuru Asia, termasuk Indonesia. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4GF6zyfMc6UC7E1kZ7JdaU?si=yHxW9ySNSl2ljPBa9Je2pA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-14-Mengenal-St--Fransiskus-Xaverius-Pelindung-Misi-e9b2ur',
    }
  },
  {
    "episode": 15,
    "judul": 'Sakramen Pengakuan Dosa',
    "description": 'Selama Masa Adven ini, umat Kristiani diajak untuk lebih mendekatkan diri dengan Tuhan. Salah satu langkahnya adalah melalui Sakramen Tobat atau Pengakuan Dosa. Pada episode ini, kita berupaya mengenal dan memahami lebih jauh esensi dari mengaku dosa. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/6ZYFce2FOrC1WP51ak99yM?si=kxSqhN5WSvCFWIZK3s2IcA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-15-Sakramen-Pengakuan-Dosa-e9celq',
    }
  },
  {
    "episode": 16,
    "judul": 'Belajar Mendengarkan dari Bunda Maria',
    "description": 'Mempelajari bagaimana Bunda Maria menyonsong kelahiran Yesus, Putra-Nya. Belajar pula tentang teladan mau untuk "mendengarkan" dari Bunda Maria. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/3Obdi1GMmwRdCAqgYkpvDg?si=935KGnhvRZKUCIqU7vzTCQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-16-Belajar-Mendengarkan-dari-Bunda-Maria-e9ejpf',
    }
  },
  {
    "episode": 17,
    "judul": 'Belajar Bertanggung Jawab dari Santo Yosef ',
    "description": 'Mempelajari bagaimana situasi dan peran Santo Yosef menyongsong kelahiran Yesus, Putra-Nya. Belajar pula tentang teladan mau untuk"bertanggung jawab" dari Santo Yosef. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4SR7vKioDZqjLCQgqYKusI?si=GpCiuXRBSf6RfpIAHaU2ZA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-17-Belajar-Bertanggung-Jawab-dari-Santo-Yosef-e9goaf',
    }
  },
  {
    "episode": 18,
    "judul": 'Belajar Kerendahan Hati dari Santa Elisabeth',
    "description": 'Figur Santa Elisabeth hanya tersebut dalam injil Lukas, dan kisah mengenai Santa Elisabeth agak jarang terdengar. Dalam rangka mempersiapkan natal, mari kita melihat bagaimana situasi dan peran Santa Elisabeth Menyongsong kelahiran Yesus. Belajar pula tentang teladan mau untuk "rendah hati" dari Santa Elisabeth.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/594mXm2fbRSlIBNTeqfmr7?si=YmvLz1K2TZ2zjvKPAAyMSg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-18-Belajar-Kerendahan-Hati-dari-Santa-Elisabeth-e9iooa',
    }
  },
  {
    "episode": 19,
    "judul": 'Belajar Berharap dari Santo Zakaria',
    "description": 'Zakariah adalah ayah dari St. Yohanes Pembaptis dan suami St. Elisabeth. Peristiwa ajaib dialami sebelum kelahiran putranya yang akan menjadi tokoh besar dalam sejarah penyelamatan Allah, yang di syukurinya dalam kidung syukur. Belajar pula tentang teladan mau "berharap" juga dari Santo Zakariah. ',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/594mXm2fbRSlIBNTeqfmr7?si=YmvLz1K2TZ2zjvKPAAyMSg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-19-Belajar-Berharap-dari-Santo-Zakaria-e9m5md',
    }
  },
  {
    "episode": 20,
    "judul": 'Belajar jadi "Saksi" Sukacita Natal bersama para Gembala, Hewan-Hewan, dan Malaikat',
    "description": 'Makna mendalam kehadiran sosok gembala, hewan-hewan, dan malaikat dalam Kandang Natal sebagai penggenapan Janji Keselamatan Allah di masa silam dengan hadirnya Ia yang terbaring di palungan, di Bethlehem. Belajar pula bagaimana menjadi saksi Sukacita Natal dan mensyukuri peran kita sebagai saksi iman, apapun situasi dan kondisinya. Mari kita sambut Ia yang akan lahir pada Hari Raya Natal. Yuk didengerin sebagai bahan refleksi Natal :)',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/6AoNiiHb3fCFVdvm7qpQpx?si=9Pqg9m6rR_C0LXGNcJhjbQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-20-Makna-Kehadiran-Para-Saksi-kelahiran-Yesus-e9ok65',
    }
  },
  {
    "episode": 21,
    "judul": 'Kanak-Kanak Suci sebagai Martir Pertama',
    "description": 'Kelahiran Yesus membuat Raja Herodes Agung marah. Herodes memerintahkan semua bayi yang berusia di bawah 2 tahun yang ada di Betlehem dibunuh dengan maksud untuk membunuh Yesus. Setiap tanggal 28 Desember, bersama Gereja Katolik sedunia, kita merayakan Pesta Kanak-Kanak Suci. Kita menghormati kanak-kanak kecil ini sebagai martir pertama. Belajar pula tentang teladan "mensyukuri kehidupan" dari mereka.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/49cm4ad0YOGOjPH1TXb6oD?si=2OFR6iAqRtqHZk3NpPZd0w',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-21-Kanak-Kanak-Suci-sebagai-Martir-Pertama-e9qf71',
    }
  },
  {
    "episode": 22,
    "judul": 'Perjalanan para Majus menemui "Bintang Timur"',
    "description": 'Tokoh Tiga Raja dari Timur atau para Majus, yakni Caspar, Melkhior, dan Balthasar selalu mewarnai natal. Mereka datang dari jauh untuk menemui "Bintang Timur" (Orient), yang adalah bayi Yesus. Belajar dari mereka untuk memaknai pesan Tuhan dan terbuka pada sesuatu yang baru | Selamat tahun baru untuk sobat peziarah semuanya',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4d0fWp7ZS7aoJIgBs6sz44?si=lm7GhoQ-TeSqdZmGVGS1Sg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-22-Perjalanan-para-Majus-menemui-Bintang-Timur-e9unod',
    }
  },
  {
    "episode": 23,
    "judul": 'Utusan yang Menyiapkan Jalan bagi Tuhan ',
    "description": 'Santo Yohanes Pembaptis adalah tokoh besar yang mempersiapkan kehadiran Yesus dan"menyambut" Yesus sejak ia berada dalam kandungan Ibunya. Ia adalah tokoh yang menjembatani Perjanjian Lama dan Perjanjian Baru. Kenabiannya amat disegani dan mampu mengundang Israel untuk bertobat dan dibaptis di tengah gemuruh Sungai Yordan. Belajar menjadi "Saksi Iman" dari Santo Yohanes Pembaptis.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/35WjjQiuTSYOfmr1dpCX3F?si=CUCXuIO1Rvmq2QpW9OBJRw',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-23-Utusan-yang-Menyiapkan-Jalan-bagi-Tuhan-e9uo5r',
    }
  },
  {
    "episode": 24,
    "judul": 'Memahami Konsep Iman, Amin',
    "description": 'Tema YOUCAT Indonesia bulan ini adalah "Beriman Bukan Recehan". Episode ini membahas definisi iman dan mengapa iman bukanlah sesuatu yang receh. Belajar juga tentang sumber-sumber iman, serta apakah iman bertentangan dengan akal budi dan ilmu pengetahuan.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/1gxNPESxI0F9jCTvR4ZXUi?si=2INUu9r2RsO3LYkbGxt5Xg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-24-Memahami-Konsep-Iman--Amin--Aman-ea3hnj',
    }
  },
  {
    "episode": 25,
    "judul": 'Sesatkah Tradisi Devosi?',
    "description": 'Gereja Katolik mengakui Tradisi Suci sebagai sumber iman selain Kitab Suci. Pertanyaannya, apa yang dimaksud Tradisi Suci dan mana yang lebih penting, Tradisi Suci atau Kitab Suci? Kami turut membedah lebih dalam terkait salah satu tradisi suci yaitu devosi.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/7tjunjroaWn3diBNMKu4GS?si=02YFaJVzTdeItNrNp9EQtQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-25-Sesatkah-Tradisi-Devosi-ea5ukr',
    }
  },
  {
    "episode": 26,
    "judul": 'Kitab Suci: Kitab Mitos atau Fakta?',
    "description": 'Selain Tradisi Suci, Gereja Katolik mengakui Kitab Suci sebagai sumber iman. Sebuah buku yang berabad-abad lamanya menjadi "best seller book", dan mengubah hidup banyak orang. Pertanyaannya, Kitab Suci itu berasal dari kisah mitos atau fakta, serta bagaimana proses kitab suci disusun?',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/71dsu8nNsabMK1jndko7Se?si=RYqcJS85T0WUbx5vU2F24Q',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-26-Kitab-Suci-Kitab-Mitos-atau-Fakta-ea84vg',
    }
  },
  {
    "episode": 27,
    "judul": 'Sejarah dan Kisah-Kisah Perjanjian Lama',
    "description": 'Kitab Suci Perjanjian Lama merupakan kisah selama 1.000 tahun. Episode ini membahas bagaimana sebenarnya Kitab Suci Perjanjian Lama itu bisa hadir dan berkembang. Mengapa ada istilah Perjanjian Lama dan Perjanjian Baru? Dan, mengapa ada begitu banyak jenis kitab di dalam Kitab Suci Perjanjian Lama? Yuk belajar dan selamat mencintai Kitab Suci.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/5nNVLjJKMXylvUcc2r0Ww5?si=nXzlhJbXT3m6mSyGocQeqg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-27-Sejarah-dan-Kisah-Kisah-Perjanjian-Lama-eaaihl',
    }
  },
  {
    "episode": 28,
    "judul": 'Sejarah dan Kisah-Kisah Perjanjian Baru',
    "description": 'Pada Minggu Biasa III lalu, Gereja mengundang kita merayakan Minggu Sabda Allah. Kita diundang untuk mencintai Kitab Suci. Nah, Podcast Peziarah feat YOUCAT Indonesia secara khusus menghadirkan 3 (tiga) Podcast yang mengulik tentang Kitab Suci, yakni: (1) Episode 26: Kitab Suci: Kitab Mitos atau Fakta? (2) Episode 27: Sejarah dan Kisah-Kisah Perjanjian Lama (3) Episode 28: Sejarah dan Kisah-Kisah Perjanjian Baru. Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/6IhoRFMQpgcmdYn1oJF9ds?si=fW0KcjfnSJq3fxdc_4OljA',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-28-Sejarah-dan-Kisah-Kisah-Perjanjian-Baru-ead5ek',
    }
  },
  {
    "episode": 29,
    "judul": 'Mengenal Sumber-Sumber Iman',
    "description": 'Mencermati sumber-sumber iman, yaitu Tradisi Suci, Kitab Suci, dan Magisterium. Membahas pula tentang Infalibilitas (ketidaksalahan) Paus, berikut makna dan syaratnya. Mari terus memperdalam Tradisi Suci dengan mengakrabi Kitab Suci, tenggelam dalam Liturgi dan perayaan-perayaan Gereja, dan memiliki Devosi pribadi!',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/0gmsD819O0khwLHUZBFz90',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-29-Mengenal-Sumber-Sumber-Iman-eafr9b',
    }
  },
  {
    "episode": 30,
    "judul": 'Menjadi Katolik di Jazirah Arab',
    "description": '#BerimanBukanRecehan! Mungkin itulah ungkapan yang bisa mewakili perjuangan seorang Orang Muda Katolik yang kini bekerja di kawasan Jazirah Arab, yakni di Qatar. Perjuangannya untuk menemukan Gereja, hadir dalam Perayaan Ekaristi, terlibat dalam komunitas, semoga menjadi inspirasi dan teladan untuk selalu belajar dan bertumbuh, memperkuat iman kita. Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4Xay5GNhXqTkEpZnuwlptb?si=v4Am6_kwT3u3jufPYiX84w',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-30-Menjadi-Katolik-di-Jazirah-Arab-eai8av',
    }
  },
  {
    "episode": 31,
    "judul": 'Corona Virus dalam Kacamata Iman Katolik',
    "description": 'Hebohnya Corona Virus mengundang kegelisahan bahkan kepanikan. Virus Corona merebak di kota Wuhan, China, lalu mewabah di puluhan negara. Pertanyaannya, bagaimana Iman Katolik memandang fenomena ini? Apakah ada kaitannya dengan kegagalan manusia memainkan peran dan tugasnya sebagai "penjaga keutuhan ciptaan"? Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/3wpMCRiJW0QOnSGxY0y9Oi?si=6tvBfFtYQkOEEwqvzZer_w',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-31-Corona-Virus-dalam-Kacamata-Iman-Katolik-eakft6',
    }
  },
  {
    "episode": 32,
    "judul": '"Kerajaan-Kerajaan" VS Kerajaan Allah ',
    "description": 'Merebaknya fenomena "kerajaan-kerajaan" di seantero Indonesia menjadi penting untuk kita refleksikan. Apa yang sebenarnya terjadi? Bagaimana perbandingan "Kerajaan-Kerajaan" tersebut dengan Kerajaan Allah atau Kerajaan Surga yang diwartakan oleh Yesus dan Gereja? Mencermati pula segi-segi pemerintahan, kemasyarakatan, dan pelayanan publik yang praktiknya sangat bernilai Injili dan turut mencerminkan hadirnya Kerajaan Allah. Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/6S5skU7asr7SOBlvei6hZh?si=RoJS13sHTsOYGdpJopMokw',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-32-Kerajaan-Kerajaan-VS-Kerajaan-Allah-eam7p6',
    }
  },
  {
    "episode": 33,
    "judul": 'Mencintai Allah Melalui Ekaristi',
    "description": 'Membahas ekaristi sebagai sumber dan puncak iman Kristiani (Lumen Gentium 11). Sayangnya, terkadang sebagian dari kita merasa Ekaristi itu membosankan. Lalu, bagaimana cara kita bisa mencintai Allah lewat Ekaristi? Simak pula pengalaman William tentang pengalamannya belajar mencintai Ekaristi sebagai seorang yang belum dibaptis.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/0tGVh5RU8vRr5Ogwi7iV6H',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-33-Mencintai-Allah-melalui-Ekaristi-eap3ac',
    }
  },
  {
    "episode": 34,
    "judul": '"Dari Valentinus-mu" ',
    "description": 'Haram enggak sih merayakan hari valentine? Dan dari mana sebenarnya asal muasal hari valentine? Yuk kita belajar terlebih dahulu dari St. Valentinus dan mencoba memaknai hari kasih sayang. Selamat hari valentine sobat peziarah! Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/508hFSlVBDOlXD8K0RcJas?si=xUY2jx1vSm2kFQqrxv8HDQ',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-34-Dari-Valentinus-mu-ear6ko',
    }
  },
  {
    "episode": 35,
    "judul": 'Mimpi Besar YOUCAT Indonesia',
    "description": '4 tahun berjalan sudah usia YOUCAT Indonesia. Masih belia, tetapi menyimpan asa. Salah satunya adalah dengan membangun sebuah Youth Center sebagai dedikasi untuk anak muda. Terima kasih kepada Savi (Laurent Saviour Tanujaya) yang telah memupuk asa YOUCAT Indonesia untuk terus bermimpi, melalui ide dan karyanya yang luar biasa. Semoga suatu saat nanti, mimpi ini dapat terwujud untuk menjadi wadah bagi anak muda berkarya dan menumbuhkan imannya. Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/2SYgxoODKLe3PkWs1a3yR5?si=R09pFGwsRdKMXyAoBF9mHg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-35--Mimpi-Besar-YOUCAT-Indonesia-eat0i0',
    }
  },
  {
    "episode": 36,
    "judul": 'Menghidupi dan Memaknai Panggilan Allah',
    "description": '"Panggilan itu adalah sebuah misteri.." Demikian kerap kita dengar. Tapi bagaimana mereka yang menerima panggilan, menjawab, menjalaninya, dan mencoba mencintai Allah dalam jalan panggilan itu dengan segala dinamikanya, jatuh bangunnya, dan suka dukanya. Simak sharing dan refleksi dari beberapa Frater dari Seminari Tinggi St. Yohanes Paulus II, Keuskupan Agung Jakarta. Terima kasih kepada Diakon Patrick Slamet Widodo, Fr. Agustinus Ivan, Pr., Fr. Ignatius Wahyudi Pauling, Pr., dan Fr. Julio Kevin Saputra, Pr yang sudah bersedia berbagi. Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/0dNWdN6eG1SGOGdTdfFPOK?si=trDcgWxxRkua4BkjwUOQtg',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-36-Refleksi-Panggilan-dari-Para-Frater-eavqf7',
    }
  },
  {
    "episode": 37,
    "judul": 'Prapaskah Sebagai Masa Pertobatan',
    "description": 'Sudah siap Prapaskah, Sobat Peziarah? Yuk sama-sama gali apa makna dari Prapaskah, makna dari Rabu Abu, serta apa hubungannya juga dengan makna Pembaptisan. Kita ulas juga beberapa pertanyaan para Sobat Peziarah seputar Prapaskah yang sudah disampaikan melalui @youcatid. Penasaran?! Yuk dengerin Podcast Peziarah yang mengulas masa 40 hari Retret Agung ini!',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4ITxgPI6rvhJhKBTZkpKZL',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Episode-40---Prapaskah-sebagai-Masa-Pertobatan-eb26mo',
    }
  },
  {
    "episode": 38,
    "judul": 'Melihat Penderitaan Yesus melalui Jalan Salib',
    "description": 'Salah satu tradisi Gereja Katolik dalam Masa Prapaskah adalah Ibadat Jalan Salib. Bagaimana Jalan Salib bisa menjadi salah satu devosi yang cukup kuno? Bagaimana pula kita seharusnya menghayati Jalan Salib? Mengupas pula beberapa pertanyaan seputar Jalan Salib dari Sobat Peziarah yang sudah disampaikan melalui akun @youcatid. Selamat berziarah melalui Jalan Salib di Masa Prapaskah ini!  Yuk didengerin bersama...',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/2Ag2JJ8kbcio86yPILNBB7?si=mei2wQejTzG_WxpcyvG-4A',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-38--Melihat-Penderitaan-Yesus-melalui-Jalan-Salib-eb41p7',
    }
  },
  {
    "episode": 39,
    "judul": 'Doa Bapa Kami, Doa yang Sempurna',
    "description": 'Doa Bapa Kami adalah doa yang revolusioner, yang transformatif, dan bahkan menurut St. Thomas Aquinas adalah doa yang sempurna. Mengapa? Mari cermati makna mendalam di balik doa yang diajarkan oleh Yesus sendiri. Mengenal pula ketujuh permohonan yang ada dalam Doa Bapa Kami ini. Marilah kita berani berdoa..."',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/6SS21wDoLhX64s1Mlvz23l',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-39--Doa-Bapa-Kami--Doa-yang-Sempurna-eb6n5r',
    }
  },
  {
    "episode": 40,
    "judul": 'Adorasi Sakramen Mahakudus',
    "description": 'umat Pertama menjadi salah satu hari penting untuk umat Katolik, terutama mereka yang memiliki Devosi kepada Sakramen Mahakudus atau Hati Kudus Yesus. Episode ini membahas Adorasi sebagai salah satu bentuk Devosi kepada Sakramen Mahakudus dan Hati Kudus Yesus. Mengulas lebih jauh apa itu Adorasi, bagaimana asal mulanya, dan bagaimana tips untuk mencintai Adorasi. Membahas pula mengapa Devosi kepada Sakramen Mahakudus menjadi begitu spesial dan tidak biasa.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4sJy6EAaHIX3MHv3Dm1hmx',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-40--Adorasi-Sakramen-Mahakudus-eb9925',
    }
  },
  {
    "episode": 41,
    "judul": 'Iblis dan Praktik Eksorsisme',
    "description": 'Jika Allah adalah kasih, mengapa ada kejahatan? Mengapa ada iblis? Episode kali ini mencoba mengulas tentang Iblis atau Roh Kenajisan, bagaimana ia muncul dan apa yang ia lakukan. Juga mengulas tentang eksorsisme dalam ajaran Gereja dan beberapa kasus-kasusnya.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/6qmWlvM4eWosnUiFObrzJy',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-41--Iblis-dan-Praktik-Eksorsisme-ebcicf',
    }
  },
    {
    "episode": 42,
    "judul": 'Konsep Dosa',
    "description": 'Mengupas lebih mendalam tentang "DOSA", apa saja hal-hal yang menyebabkan kita masuk dalam dosa, akibat dari dosa, "situasi berdosa", dan cara kita lepas dari dosa. Membahas pula tentang "DOSA ASAL" dan apakah Adam pantas untuk kita salahkan akibat kejatuhannya.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/4KnBr66AunLAefqKwQ6mEU',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-42--Konsep-Dosa-ebfi7l',
    }
  },
    {
    "episode": 43,
    "judul": 'Tujuh Dosa Pokok',
    "description": 'Membahas tentang apa saja 7 Dosa Pokok itu dan bagaimana cara untuk lepas dari jeratannya, serta membahas pula tentang Dosa Berat dan Dosa Ringan. Mencermati pula bagaimana kita perlu bersikap dalam usaha lepas dari dosa, serta sikap kita terhadap Gereja yang kudus sekaligus "berdosa". Follow juga IG kami: @peziarahkatolik dan @youcatid.',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/7h8Km3YGNVizFW4Q63t3km',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-43--Tujuh-Dosa-Pokok-ebis1b',
    }
  },
    {
    "episode": 44,
    "judul": 'Minggu Laetare: Sukacita di tengah Kekhawatiran',
    "description": 'Dalam Minggu Prapaskah IV kita merayakan Minggu Laetare. Laetare diambil dari kata pertama dalam antifon pembukaan Perayaan Ekaristi Minggu Prapaskah IV yang maknanya "Bersukacita!" Perayaan yang hampir senada dengan Minggu Gaudete dalam Masa Adven. Membahas juga makna warna "rose" dan tradisi di baliknya, beserta tradisi "Rose Sunday" dan "Mothering Sunday" untuk menggali inspirasi bagaimana kita bisa merayakan Minggu Laetare. Yuk follow kami: IG: @peziarahkatolik & @youcatid | Blog: peziarahkatolikid.blogspot.com',
    "tautan": {
      "spotify": 'https://open.spotify.com/episode/58XwpoSFoYfQFnFmnjE4nD',
      "anchor": 'https://anchor.fm/podcast-peziarah/episodes/Eps-44--Minggu-Laetare-Sukacita-di-tengah-Kekhawatiran-ebn3oh',
    }
  },
];

export const specialPodcasts = [
    {
        "order": 1,
        "judul": "Salah Mantan Pastor Memahami Tahapan Pendidikan Calon Imam",
        "description": "Beberapa waktu terakhir ini kerap muncul di media sosial beberapa penceramah yang menjual predikat 'Mantan Imam' yang rupanya cukup laku dan bombastis. Permasalahannya terletak di kekeliruan mengenal dan menjelaskan tahapan pendidikan calon Imam dan perlu untuk diluruskan. Membahas pula tentang kekalnya rahmat Baptisan, walau memilih 'pindah' agama. Mengingat pula perkataan Yesus, 'Tetapi barangsiapa menyangkal Aku di depan manusia, Aku juga akan menyangkalnya di depan Bapa-Ku yang di sorga.' (Mat 10:33)  Yuk didengerin bersama...",
        "tautan": {
            "spotify": "https://open.spotify.com/episode/4bSSO99Q0sPzuQKOsOqGiL?si=bDs59BQeTjuOHIBZzi0qHg",
            "anchor": "https://anchor.fm/podcast-peziarah/episodes/Edisi-Khusus-Keliru-Mantan-Pastor-Memahami-Tahapan-Pendidikan-Calon-Imam-eb5lo3"
        }
    },
    {
        "order": 2,
        "judul": "Homili Paus Fransiskus dalam Berkat Urbi et Orbi",
        "description": "Sendiri. Dalam dingin. Ditemani hujan. Paus Fransiskus meneguhkan seluruh dunia, seluruh Gereja dengan homili dan berkat Urbi et Orbi Luar Biasa pada 27 Maret 2020 dengan Sakramen Mahakudus. Terima kasih kepada RP. Charles Virgenius, O.Carm. yang telah menerjemahkan Homili Paus Fransiskus ke dalam Bahasa Indonesia dengan segala keterbatasan. \"Mengapa engkau takut?\" \"Janganlah cemas, janganlah takut, di dalam Tuhan berlimpah rahmat... Serahkan.. Tuhan..\" (lirik dari instrumen lagu \"Nada Te Turbe\"). Follow IG: @peziarahkatolik dan @youcatid. Terjemahan Homili Paus Fransiskus dapat dibaca di peziarahkatolikid.blogspot.com. (Sumber gambar: Reuters pic)",
        "tautan": {
            "spotify": "https://open.spotify.com/episode/1qC37siivm6DZXgCcl4xxF",
            "anchor": "https://anchor.fm/podcast-peziarah/episodes/Edisi-Khusus-Homili-Paus-Fransiskus-dalam-Berkat-Urbi-et-Orbi-ec27i1"
        }
    }
];


// WEBPACK FOOTER //
// ./src/data/podcasts.js